export default __webpack_public_path__ + "static/media/topic-magnet.c4868178.png";